<template>
	<tr
		ref="file"
		class="table__main folder-container"
		@drop="drop($event, newFolder.id)"
		@dragover="dragover"
		@dragleave="dragleave"
		:class="selected ? 'selected' : ''"
		@click="oneClick"
	>
		<td class="table__cell table__cell--center">
			<img class="table__icon" src="/img/file-types/folder.svg" alt="type" /></td>
		<td>
			<span class="table__name">{{ newFolder.name }}</span>
			<br /><span class="table__description">{{ getDate(newFolder.uploaded_at) }}</span>
			<button 
				class="table__button button button--secondary button--small" 
				@click.stop="openFolder()"
			>
				Ouvrir
			</button>
		</td>	
		<td>
			<img
				@click="onClickShareStudent()"
				class="table__share"
				:src="isSharedWithStudents ? '/img/share-line.svg' : '/img/share.svg'"
				alt="type"
			/>
		</td>
		<td>
			<img
				@click="onClickShareTeacher()"
				class="table__share" 
				:src="isSharedWithTeachers ? '/img/share.svg' : '/img/share-line.svg'" 
				alt="type"
			/>
		</td>
		<td>
			<img class="table__options" @click="isPopUpVisible = !isPopUpVisible" :src='`/img/three-dots.png`' alt="type" />
		</td>
	</tr>
	<Teleport to="body">
		<pop-up-menu-folder
			v-if="isPopUpVisible"
			:x="x"
			:y="y"
			@close="isPopUpVisible = !isPopUpVisible"
			@remove="removeFolder"
			@showPopUpEditFolder="isPopUpEditFolderVisible = !isPopUpEditFolderVisible"
			:folder="newFolder"
		/>
	</Teleport>
	<Teleport to="body">
		<pop-up-edit-folder
			v-if="isPopUpEditFolderVisible"
			@close="isPopUpEditFolderVisible = !isPopUpEditFolderVisible"
			:folder="newFolder"
			@getFolders="changeFolderName"
		/>
	</Teleport>
	<PopUpShareFile 
		v-if="showShareFolder"
		type="folder"
		:id="newFolder.id"
		:sharedStudentIds="newFolder.shared_with_students"
		@close="showShareFolder = !showShareFolder" 
		@update:shared_with_students="updateSharedStudents"
	/>
	<PopUpSharePlaceFile
		v-if="showTeacherSharePopup"
		type="folder"
		:id="newFolder.id"
		:classId="parseInt($route.params.id)"
		:sharedWithSpecificTeachers="newFolder.shared_with_specific_teachers || []"
		:fileData="newFolder"
		@close="showTeacherSharePopup = false"
		@submit="handleTeacherShare"
		@stopShare="handleStopTeacherShare"
	/>
</template>

<script>
import { createFileService, updateFileService } from '../../../../services/filesService'
import { updateFolderService, createFolderService } from '../../../../services/foldersService'
import PopUpEditFolder from '../../../PopUp/Class/PopUpEditFolder.vue'
import PopUpMenuFolder from '../../../PopUp/Class/PopUpMenuFolder.vue'
import PopUpShareFile from '../../../PopUp/PopUpShareFile.vue'
import PopUpSharePlaceFile from '../../../PopUp/PopUpSharePlaceFile.vue'

export default {
	components: { PopUpMenuFolder, PopUpEditFolder, PopUpShareFile, PopUpSharePlaceFile },
	props: {
		folder: Object,
		selected: Boolean
	},
	emits: ['remove', 'getFiles', 'getFolders', 'select', 'redirect'],
	data() {
		return {
			showShareFolder: false,
			showTeacherSharePopup: false,
			newFolder: {},
			delay: 700,
			clicks: 0,
			timer: null,
			isPopUpVisible: false,
			isPopUpEditFolderVisible: false
		}
	},
	computed:{
		initials(){
			return `${this.newFolder.teacher.first_name[0]}${this.newFolder.teacher.last_name[0]}`
		},
		isSharedWithStudents(){
			return this.newFolder.shared_with_students.length === 0
		},
		isSharedWithTeachers(){
			return this.newFolder.shared_with_teachers
		}
	},
	methods: {
		updateSharedStudents(newList) {
			this.newFolder.shared_with_students = newList
		},
		onClickShareStudent(){
			this.showShareFolder = true
		},
		onClickShareTeacher(){
			this.showTeacherSharePopup = true
		},
		handleTeacherShare(shareData) {
			const payload = {
				shared_with_teachers: true,
				subject: shareData.subject,
				level: shareData.level,
				chapter: shareData.chapter,
				is_public: shareData.is_public,
				shared_teacher_emails: shareData.shared_with_specific_teachers
			}

			updateFolderService(this.newFolder.id, payload)
			.then(()=>{
				this.newFolder.shared_with_teachers = true
				this.newFolder.shared_with_specific_teachers = shareData.shared_with_specific_teachers
				this.newFolder.is_public = shareData.is_public
				// Stocker les informations de partage localement pour les réutiliser
				this.newFolder.subject = shareData.subject
				this.newFolder.level = shareData.level
				this.newFolder.chapter = shareData.chapter
				this.$store.state.toast = {
					status: 'success',
					text: 'Dossier partagé avec les professeurs',
				}
			})
			.catch(()=>{
				this.$store.state.toast = {
					status: 'error',
					text: 'Erreur lors du partage',
				}
			})
		},
		handleStopTeacherShare() {
			const payload = {
				shared_with_teachers: false
			}

			updateFolderService(this.newFolder.id, payload)
			.then(()=>{
				this.newFolder.shared_with_teachers = false
				this.$store.state.toast = {
					status: 'success',
					text: 'Partage arrêté',
				}
			})
			.catch(()=>{
				this.$store.state.toast = {
					status: 'error',
					text: 'Erreur lors de l\'arrêt du partage',
				}
			})
		},
		openFolder() {
			this.$emit('redirect')
		},
		changeFolderName(e) {
			this.newFolder.name = e
		},

		removeFolder(e) {
			this.$emit('remove', e)
		},

		getDate(e) {
			return e.slice(0, 10)
		},
		oneClick() {
			this.clicks++
			this.$emit('select', this.folder.id)
			if (this.clicks === 1) {
				this.timer = setTimeout(() => {
					this.clicks = 0
				}, this.delay)
			} else {
				clearTimeout(this.timer)
				this.$emit('redirect')

				this.clicks = 0
			}
		},
		dragover(event) {
			event.preventDefault()
			event.stopPropagation()
			if (!event.currentTarget.classList.contains('drag-enter')) {
				event.currentTarget.classList.remove('not-drag-enter')
				event.currentTarget.classList.add('drag-enter')
			}
		},
		dragleave(event) {
			event.stopPropagation()
			event.currentTarget.classList.add('not-drag-enter')
			event.currentTarget.classList.remove('drag-enter')
		},


		async drop(event, parentFolder) {
			// Empêche le conteneur parent de gérer aussi le drop (évite le double upload)
			event.preventDefault()
			event.stopPropagation()
			if (event.dataTransfer.getData('itemID')) {
				const fileId = event.dataTransfer.getData('itemID')
				const data = {
					parent_folder_id: parentFolder
				}
				updateFileService(fileId, data)

					.then(() => {
						this.$emit('getFiles')
					})
			}
			else {
				const dt = event.dataTransfer
				const items = dt.items
				if (items && items.length && items[0].webkitGetAsEntry) {
					const tasks = []
					for (let i = 0; i < items.length; i++) {
						const entry = items[i].webkitGetAsEntry()
						if (entry) tasks.push(this.processEntry(entry, parentFolder))
					}
					await Promise.all(tasks)
					this.$emit('getFiles')
				} else {
					// Fallback: multiples fichiers
					this.$refs.file.files = dt.files
					for (let i = 0; i < this.$refs.file.files.length; i++) {
						await this.uploadOneFile(this.$refs.file.files[i], parentFolder)
					}
					this.$emit('getFiles')
				}
			}
			event.currentTarget.classList.add('not-drag-enter')
			event.currentTarget.classList.remove('drag-enter')
		}
		,
		async uploadOneFile(file, parentFolderId) {
			const data = new FormData()
			data.append('name', file.name)
			if (parentFolderId) data.append('parent_folder_id', parentFolderId)
			data.append('class_id', this.$route.params.id)
			data.append('file_upload', file)
			await createFileService(data)
		},
		async ensureFolder(name, parentFolderId) {
			const payload = {
				name,
				class_id: this.$route.params.id,
				parent_folder_id: parentFolderId || null
			}
			const created = await createFolderService(payload)
			return created?.id
		},
		async processEntry(entry, parentFolderId) {
			if (entry.isFile) {
				await new Promise((resolve, reject) => {
					entry.file(async file => {
						try { await this.uploadOneFile(file, parentFolderId); resolve() } catch (e) { reject(e) }
					})
				})
			} else if (entry.isDirectory) {
				const folderId = await this.ensureFolder(entry.name, parentFolderId)
				await new Promise((resolve, reject) => {
					const reader = entry.createReader()
					const readEntries = () => {
						reader.readEntries(async entries => {
							if (!entries.length) { resolve(); return }
							try {
								for (const ent of entries) {
									await this.processEntry(ent, folderId)
								}
								readEntries()
							} catch (e) { reject(e) }
						})
					}
					readEntries()
				})
			}
		}
	},
	created() {
		this.newFolder = this.folder
		window.addEventListener('mousemove', (e) => {
			this.x = e.clientX
			this.y = e.clientY
		})
	},
}
</script>

<style>
</style>
